import moment from 'moment-timezone'

export default function humanDateTime(value) {
    return moment.utc(value).tz('Europe/Copenhagen').format('DD/MM-YY HH:mm:ss')
}
